import { useNavigation } from '../hooks/useNavigation';
import { useSections } from '../hooks/useSections';
import PublicLayout from '../components/layout/PublicLayout';
import MainHome from './MainHome';
import HIHome from './HIHome';
import SectionPage from './SectionPage';
import TopicPage from './TopicPage';

export default function PublicApp() {
  const nav = useNavigation();
  const { sections, loading } = useSections();

  const mainSections = sections?.main || [];
  const hiSections = sections?.['health-insurance'] || [];

  const renderContent = () => {
    if (loading) {
      return (
        <div className="flex items-center justify-center py-20">
          <div className="w-8 h-8 border-4 border-content-border border-t-oak-green rounded-full animate-spin" />
        </div>
      );
    }

    switch (nav.currentPage.type) {
      case 'home':
        return (
          <MainHome
            sections={mainSections}
            goToSection={nav.goToSection}
            goToHI={nav.goHIHome}
          />
        );
      case 'hi-home':
        return (
          <HIHome
            sections={hiSections}
            goToHISection={nav.goToHISection}
          />
        );
      case 'section':
        return (
          <SectionPage
            sectionId={nav.currentPage.id}
            goHome={nav.goHome}
            goToSection={nav.goToSection}
            goToTopic={nav.goToTopic}
          />
        );
      case 'hi-section':
        return (
          <SectionPage
            sectionId={nav.currentPage.id}
            goHome={nav.goHome}
            goToSection={nav.goToHISection}
            goToTopic={nav.goToHITopic}
            isHI
            goHIHome={nav.goHIHome}
          />
        );
      case 'topic':
        return (
          <TopicPage
            topicId={nav.currentPage.topicId}
            sectionId={nav.currentPage.sectionId}
            currentApp={nav.currentApp}
            goHome={nav.goHome}
            goToSection={nav.goToSection}
          />
        );
      case 'hi-topic':
        return (
          <TopicPage
            topicId={nav.currentPage.topicId}
            sectionId={nav.currentPage.sectionId}
            currentApp={nav.currentApp}
            goHome={nav.goHome}
            goToSection={nav.goToHISection}
            isHI
            goHIHome={nav.goHIHome}
          />
        );
      default:
        return <MainHome sections={mainSections} goToSection={nav.goToSection} goToHI={nav.goHIHome} />;
    }
  };

  return (
    <PublicLayout
      currentApp={nav.currentApp}
      currentPage={nav.currentPage}
      mainSections={mainSections}
      hiSections={hiSections}
      currentSectionId={nav.getCurrentSectionId()}
      currentTopicId={nav.getCurrentTopicId()}
      goHome={nav.goHome}
      goToSection={nav.goToSection}
      goToTopic={nav.goToTopic}
      goHIHome={nav.goHIHome}
      goToHISection={nav.goToHISection}
      goToHITopic={nav.goToHITopic}
    >
      {renderContent()}
    </PublicLayout>
  );
}
